let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7nLOm")).then(() => parcelRequire('8A9An'));